module.exports = __webpack_public_path__ + "Roboto-Regular.081b11ebaca8ad30fd09.woff";


//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/node_modules/roboto-fontface/fonts/roboto/Roboto-Regular.woff
// module id = ../../../../roboto-fontface/fonts/roboto/Roboto-Regular.woff
// module chunks = styles